<template>
  <div>
    <MainPageHeader/>
    <PageContent>
      <AccountForms
          v-if="account"
          :account="account"
          :addressesEditModes="addressesEditModes"
          :passwordEditable="passwordEditable"
          @editAddress="editAddress"
          @saveChanges="saveChanges"
          @editPassword="editPassword"
          @savePassword="savePassword"
          @delete="deleteAccount"
      />
    </PageContent>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!account && !loadError"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue';
import PageContent from '../components/generic/PageContent.vue';
import AccountForms from '../components/accountView/AccountForms.vue';
import PageNotFound from '../components/PageNotFound.vue';
import ContentLoader from '../components/ContentLoader.vue';
import { cancelAddressEditing } from '../helpers/accountEditHelper';
import { getAccountService } from '../services/accountService';
import { ADMIN } from '../types/role.types';
import { limitView } from '../helpers/permissionHelper';
import '../types/account.types';

export default {
  name: 'EditAccount',
  components: {
    MainPageHeader,
    PageContent,
    AccountForms,
    PageNotFound,
    ContentLoader,
  },
  data() {
    return {
      account: null,
      copyAccount: null,
      loadError: null,
      addressesEditModes: {},
      passwordEditable: false,
    };
  },
  methods: {
    async editAddress(index) {
      const accountChanges = await cancelAddressEditing(this.$route.params.account, this.addressesEditModes);
      if (accountChanges) {
        this.account = JSON.parse(JSON.stringify(this.copyAccount))
      }

      this.addressesEditModes = {
        [index]: !this.addressesEditModes[index],
      };
      this.passwordEditable = false;
    },
    async saveChanges() {
      const result = await getAccountService().updateAccount(this.account);

      if (result) {
        this.addressesEditModes = {};
      }
    },
    async editPassword() {
      this.passwordEditable = !this.passwordEditable;

      const accountChanges = await cancelAddressEditing(this.$route.params.account, this.addressesEditModes);
      if (accountChanges) {
        this.account = {
          ...this.account,
          ...accountChanges,
        };
      }
      this.addressesEditModes = {};
    },
    async savePassword({ currentPassword, newPassword }) {
      await getAccountService().updatePassword(this.account.key, currentPassword, newPassword);
      this.passwordEditable = false;
    },
    async deleteAccount() {
      const result = await getAccountService().deleteAccount(this.account.key);
      if (result) {
        this.$router.push({
          name: 'account-list',
        });
      }
    },
  },

  async mounted() {
    if (await limitView(this.$router, [ADMIN])) {
      return;
    }

    this.account = await getAccountService().getAccount(this.$route.params.account);

    this.copyAccount = JSON.parse(JSON.stringify(this.account))

    if (this.account === null) {
      this.loadError = 'The account with the specified id doesn\'t exist';
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
</style>
